// ambient.service.ts — cliente das rotas de ambiente do alfredo-central-backend.
//
// O QUE FOI JOGADO FORA, e por quê: este arquivo tinha 8 métodos, e 7 deles
// batiam em rota que não existe (`GET /ambients?subsidiaryUuid=`, `GET
// /ambient/:uuid/stats`, `GET /ambient/:uuid/items`, e o `PATCH` com upload de
// imagem para o B2). O tipo `AmbientData` declarava `ambientImageUrl`,
// `tables`, `chairs` e um `layout` com `wallColor`/`floorType` — campos do
// mock antigo de Ambients.tsx, nenhum deles coluna de `acd."ActAmbient"` (a
// coluna real de imagem é `ambientLogoUrl`, e `layout` é uma linha de
// `acd."ActLayout"`). Nenhuma linha do repo importava este service: era um
// formulário-fantasma apodrecendo sozinho. Ele foi reescrito contra as rotas
// que EXISTEM, e só elas.
//
// `ambientType` e `capacity` são colunas NOVAS de `ActAmbient`, sendo criadas
// no backend em paralelo a este card. Enquanto a migração não subir, mandá-las
// faz o Prisma responder "Unknown argument" e derruba a gravação inteira — por
// isso são opcionais aqui e a tela avisa disso ao usuário.
import api from "./api.service";

/** Um ambiente como o backend devolve. */
export interface Ambiente {
  ambientUuid: string;
  ambientName: string;
  ambientDescription?: string | null;
  ambientType?: string | null;
  capacity?: number | null;
  /** UUID da filial dona. No JSON do backend a chave é `subsidiary` mesmo. */
  subsidiary: string;
  ambientStatus?: boolean;
  ambientLogoUrl?: string | null;
  createdAt?: string;
  updatedAt?: string;
  updatedBy?: string;
}

/** Corpo do `POST /ambient`. */
export interface NovoAmbiente {
  ambientName: string;
  ambientDescription?: string;
  ambientType?: string;
  capacity?: number;
  subsidiary: string;
  ambientStatus?: boolean;
  updatedBy: string;
}

/**
 * Corpo do `PATCH /ambient/:uuid`: os mesmos campos, todos opcionais.
 * `updatedBy` continua obrigatório — é quem assina a alteração, e o backend
 * não deduz isso do token (o handler lê do corpo).
 */
export type EdicaoDeAmbiente = Partial<Omit<NovoAmbiente, "updatedBy">> & {
  updatedBy: string;
};

// O ENVELOPE das respostas. As quatro rotas de um ambiente só respondem
// `{ dado, criado }`, e a de lista responde `{ dados }` — nunca a linha crua.
// Devolver `resposta.data` direto entregaria o envelope tipado como `Ambiente`:
// `ambiente.ambientName` sairia `undefined` sem um único erro de compilação.
export async function criarAmbiente(dados: NovoAmbiente): Promise<Ambiente> {
  const resposta = await api.post("/ambient", dados);
  return resposta.data?.dado;
}

export async function buscarAmbiente(ambientUuid: string): Promise<Ambiente> {
  const resposta = await api.get(`/ambient/${ambientUuid}`);
  return resposta.data?.dado;
}

export async function atualizarAmbiente(
  ambientUuid: string,
  dados: EdicaoDeAmbiente
): Promise<Ambiente> {
  const resposta = await api.patch(`/ambient/${ambientUuid}`, dados);
  return resposta.data?.dado;
}

export async function excluirAmbiente(ambientUuid: string): Promise<any> {
  const resposta = await api.delete(`/ambient/${ambientUuid}`);
  return resposta.data;
}

/**
 * Ambientes de uma filial.
 *
 * As telas de Configuração hoje NÃO usam isto: elas leem os ambientes da
 * travessia do `decryptedInfoToken` (organization -> companies -> subsidiaries
 * -> ambients), que já vem pronta no login. Esta função serve para quem
 * precisa do dado fresco depois de gravar, sem esperar o token ser reemitido.
 */
export async function listarAmbientesDaFilial(
  subsidiaryUuid: string
): Promise<Ambiente[]> {
  const resposta = await api.get(`/ambient/subsidiary/${subsidiaryUuid}`);
  return resposta.data?.dados ?? [];
}
